var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-card-title',[_vm._v(" بررسی پیشنهاد "),_c('v-spacer'),_c('v-btn',{attrs:{"color":"error"},on:{"click":_vm.closeForm}},[_vm._v("بستن")])],1),_c('v-divider'),_c('v-card-text',[_c('TradeRequestDirectManageResponse')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }